import { CommunicationPreferenceFormType } from "@simplyk/common";

// Saves for one form share this scope so they reach the server in the order they were made.
export const getFormCommunicationPreferencesMutationScope = (
  formId: string | undefined,
  formType: CommunicationPreferenceFormType | undefined
) => ({ id: `form-communication-preferences-${formType}-${formId}` });
